export default function FollowFacebook() {
  return (
    <a
      href="https://www.facebook.com/profile.php?id=61591575475811"
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="fb-follow-icon"
    >
      <img
        src="/facebook.png"   // ⭐ correct for a PNG in public/
        alt="Follow us on Facebook"
        className="fb-icon-img"
      />
    </a>
  );
}
